export default __webpack_public_path__ + "6a995ad62f06150b57367abc90b13530.png";